import { memo } from 'react';
import { useSelector } from 'react-redux';

import { type AssetCustomFieldValue } from '@air/api/types';

import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { centralizedClipAssetIdSelector } from '~/store/centralizedClip/selectors';
import { canChangeAssetCustomFields } from '~/utils/permissions/assetPermissions';
import { PublicAssetCustomFieldPlainText } from './PublicAssetCustomFieldPlainText';
import { PublicAssetPanelCustomFieldContainer } from './PublicAssetPanelCustomFieldContainer';

export type PublicAssetPanelCustomFieldPlainTextProps = {
  field: AssetCustomFieldValue;
};

export const PublicAssetPanelCustomFieldPlainText = memo(({ field }: PublicAssetPanelCustomFieldPlainTextProps) => {
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const { permissions } = usePublicPermissions();
  const canEditCustomFields = canChangeAssetCustomFields(permissions);

  return (
    <PublicAssetPanelCustomFieldContainer field={field}>
      <PublicAssetCustomFieldPlainText
        field={field}
        trackingLocation="asset-details"
        assetId={assetId}
        canEditCustomFields={canEditCustomFields}
      />
    </PublicAssetPanelCustomFieldContainer>
  );
});

PublicAssetPanelCustomFieldPlainText.displayName = 'PublicAssetPanelCustomFieldPlainText';
